import React, { useContext } from "react";
import "./About.scss";
import SVGAnimation from "./SVGAnimation";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import { FormContext } from "../../App";

const About = () => {
  const controls = useAnimation();
  const { formOpen, setFormOpen } = useContext(FormContext);
  const { ref, inView } = useInView();
  const paraVariants = {
    hidden: {
      opacity: 0,
      translateY: 50,
    },
    show: {
      opacity: 0.9,
      translateY: 0,
      transition: {
        ease: "easeOut",
      },
    },
  };
  const container = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 0.9,
      transition: {
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.6, // gap of 0.6 between two children
      },
    },
  };

  useEffect(() => {
    if (inView) controls.start("show");
  }, [controls, inView]);

  return (
    <div className="about">
      <h1 data-scroll data-scroll-speed="5">
        About Me
      </h1>
      <div className="aboutContent">
        <div className="aboutLeft">
          <motion.div
            className="aboutText"
            animate={controls}
            ref={ref}
            variants={container}
            initial="hidden"
          >
            <motion.p variants={paraVariants}>
              I am a problem solving enthusiast and have a knack for staying
              in-touch with the latest tech trends. From building simple static
              websites to dynamic web apps, I have worked with multiple startups
              and individuals.
              <br></br>
            </motion.p>

            <motion.p variants={paraVariants}>
              Frontend development, for me, is a form of problem-solving; I will
              be glad if I can{" "}
              <span
                className="connectLine"
                onClick={() => setFormOpen(!formOpen)}
              >
                solve yours
              </span>
              .<br></br> <br></br>
            </motion.p>
          </motion.div>
        </div>
        <div className="aboutRight">
          <div className="star"></div>
          <div className="star1"></div>
          <div className="star2"></div>
          <SVGAnimation />
        </div>
      </div>
    </div>
  );
};

export default About;
